import React, { lazy, Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BREAKPOINT } from '../../../constants/layout';
import useViewport from '@hooks/useViewport';
import { Desktop as SkeletonForDesktop } from '../../organisms/Skeletons/ChapterShowcase';
import { Mobile as SkeletonForMobile } from '../../organisms/Skeletons/ChapterShowcase';

const Desktop = lazy(() => import('./Desktop'));
const Mobile = lazy(() => import('./Mobile'));

const Module = ({ isGranted }) => {
  const { width } = useViewport();
  const [load, setLoad]  = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoad(true);
    }, 300);
  }, []);


  if (!load) {
    return null;
  }

  return (
    <Suspense fallback={width < BREAKPOINT ? <SkeletonForMobile /> : <SkeletonForDesktop />}>
      {width < BREAKPOINT ? (
        <Mobile isGranted={isGranted} />
      ) : (
        <Desktop isGranted={isGranted} />
      )}
    </Suspense>
  );
};

Module.propTypes = {
  isGranted: PropTypes.bool.isRequired,
};

export default Module;
